<template>
    <div class="flamingo" :class="{ 'is-hidden': shouldHideFlamingo }"><span><figure :style="flamingoBackgroundStyle()" /></span></div>
</template>


<script>

    import flamingopm from '../assets/img/flamingopm.png'

    export default {
        name: 'flamingo',
        computed: {
            shouldHideFlamingo() {
                return this.$store.getters.shouldHideFlamingo
            }
        },
        methods: {
            flamingoBackgroundStyle() {
                return { backgroundImage: `url(${flamingopm})` }
            }
        }
    }

</script>


<style lang="scss">
    .flamingo {
        position: fixed;
        right: 0;
        bottom: calc((100vw / #{$grass-ratio}) * 0.1);
        left: 0;
        z-index: 99;
        pointer-events: none;
        transition: transform 0.5s ease-in-out, bottom 1s ease-in-out 0.5s;

        @include mobile-landscape {
            display: none;
        }

        &.is-hidden {
            transform: translateX(100vw);
            bottom: -50vh;
        }

        @include mobile {
            bottom: calc(((100vw / #{$grass-ratio}) * 0.25) + #{$footer-mobile-height} - 10px )
        }

        span {

            display: block;
            width: $page-width;
            max-width: $page-max-width;
            margin: 0 auto;

            @include mobile {
                width: $mobile-page-width;
            }

            figure {
                position: relative;
                left: -77px;
                width: 88px;
                height: 192px;
                background-size: 88px 192px;
                background-repeat: no-repeat;

                @include mobile {
                    left: -54px;
                    width: 44px;
                    height: 96px;
                    background-size: 44px 96px;
                    transform: rotate(-5deg);
                }
            }
        }        
    }
</style>
